import { styled } from "styled-components";

export const PicksItemWrapper = styled.div`
  padding: 36px 12px;
`;
